import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext } from '@dnd-kit/sortable';
import { Virtuoso } from 'react-virtuoso';
import { twMerge } from 'tailwind-merge';
import Item from './Item';
const Container = ({ id, items, children, header, footer, outerClassName, innerClassName, draggable, disabled, scrollIndex, disableVirtualization, }) => {
    // LIST VIRTUALIZATION
    const virtuoso = useRef(null);
    const lastScrollIndexRef = useRef(undefined);
    const scrollToIndex = useCallback((index) => {
        if (virtuoso.current) {
            virtuoso.current.scrollToIndex({ index, align: 'center', behavior: 'smooth' });
        }
    }, []);
    useEffect(() => {
        if (scrollIndex !== undefined && scrollIndex !== lastScrollIndexRef.current) {
            lastScrollIndexRef.current = scrollIndex;
            scrollToIndex(scrollIndex);
        }
    }, [scrollIndex, scrollToIndex]);
    // DRAG AND DROP
    // Only include non-disabled items in sortable context
    const sortableItems = useMemo(() => {
        return items.filter((item) => !item.disabled).map((item) => item.id);
    }, [items]);
    const { setNodeRef: setDroppableRef } = useDroppable({
        id: id,
        data: {
            type: 'Container',
            id,
        },
    });
    return (_jsxs("div", { "data-container-id": id, className: twMerge('flex size-full min-w-[380px] max-w-[400px] flex-1 flex-col overflow-y-auto px-5 py-2', outerClassName), children: [_jsx("div", { className: draggable ? 'cursor-grab' : 'cursor-default', children: header }), _jsx("div", { ref: setDroppableRef, className: twMerge('flex size-full flex-col', innerClassName), children: _jsx(SortableContext, { items: sortableItems, disabled: disabled, children: disableVirtualization ? (_jsx("div", { className: "flex flex-col gap-4", children: children ? React.Children.toArray(children) : items.map((item) => _jsx(Item, { item: item }, item.id)) })) : (_jsx(Virtuoso, { ref: virtuoso, components: { List: List }, data: items, itemContent: (_index, item) => _jsx(Item, { item: item }) })) }) }), footer && _jsx("div", { className: "mt-auto", children: footer })] }));
};
const List = React.forwardRef(({ style, children }, ref) => {
    return (_jsx("div", { className: "flex flex-col gap-4", style: style, ref: ref, children: children }));
});
List.displayName = 'List';
export default Container;
//# sourceMappingURL=Container.js.map